import React from 'react';
import { Link } from 'react-router-dom';
import './employeeConversationCard.css'
import { shopIcon, locationIcon, usersIcon, starIcon,contractIcon, timerIcon  } from '../../../../utils/icons';
import useSignedImage from '../../../../hooks/useSignedImage';

const EmployeeConversationCard = ({ data, userType }) => {
  // Safely access nested properties with fallbacks (before any early returns)
  const imagePath = data?.restaurantUser?.restaurant?.profileImageUrl || '/default-restaurant-image.png';
  
  // Use signed image hook for restaurant profile image (must be called before any early returns)
  const { imageUrl: signedRestaurantImageUrl } = useSignedImage(
    imagePath, 
    '/default-restaurant-image.png'
  );

  if (!data) {
    return null; 
  }

  // Check for required nested properties
  if (!data.restaurantUser) {
    return null; 
  }

  if (!data.restaurantUser.restaurant) {
    return null;
  }

  if (!data.jobOffer) {
    return null; 
  }

  // Safely access nested properties with fallbacks
  const restaurantName = data.restaurantUser.restaurant.name || 'Restaurante no especificado';
  const jobPosition = data.jobOffer.position || 'Posición no especificada';
  const locationDisplay = data.jobOffer.location?.address || 'No hay';
  const schedule = data.jobOffer.schedule || 'No especificado';
  const yearsOfExperience = data.jobOffer.yearsOfExperience || 'No especificado';
  const vacancies = data.jobOffer.vacancies || 'No especificado';
  const description = data.jobOffer.description || 'Sin descripción';

  return (
    <div className="employee-conversation-card__container">
      <div className="employee-conversation-card__col-1">
        <img 
          className="employee-conversation-card__company-logo" 
          src={signedRestaurantImageUrl}
          alt={`Logo de ${restaurantName}`}
          onError={(e) => {
            console.warn('EmployeeConversationCard - Image failed to load:', signedRestaurantImageUrl);
            e.target.src = '/default-restaurant-image.png';
          }}
        />
        <div className="employee-conversation-card__info">
          <div className="employee-conversation-card__info-main">
            <p><strong>{jobPosition}</strong></p>
            <p id="employee-conversation-card__company-name"><strong>{restaurantName}</strong></p>
          </div>
          <div className="employee-conversation-card__info-footer-container">
            
            <div className="employee-conversation-card__icon-title-container">
             {shopIcon}
             <div className="employee-conversation-card__label-info-container">
              <p><strong>Establecimiento:</strong></p>
              <p>{restaurantName}</p>
             </div>
             
            </div>
            <div className="employee-conversation-card__icon-title-container">
              {locationIcon}
              <div className="employee-conversation-card__label-info-container">
                <p><strong>Ubicación:</strong></p>
                <p>{locationDisplay}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="employee-conversation-card__col-2">
        <div className="employee-conversation-card__icons-posts_container">
          <div className="employee-conversation-card__icon-title-container">
            {timerIcon}
            <div className="employee-conversation-card__label-info-container">
              <strong><p>Jornada:</p></strong>
              <p>{schedule}</p>
            </div>
          </div>
          <div className="employee-conversation-card__icon-title-container">
           {starIcon} 
           <div className="employee-conversation-card__label-info-container">
             <strong><p>Experiencia:</p></strong>
             <p>{yearsOfExperience}</p>
           </div>
          </div>
          <div className="employee-conversation-card__icon-title-container">
            {contractIcon}
            <div className="employee-conversation-card__label-info-container">
              <strong><p>Contrato:</p></strong>
              <p>{vacancies}</p>
            </div>
          </div>
          <div className="employee-conversation-card__icon-title-container">
            {usersIcon}
            <div className="employee-conversation-card__label-info-container">
             <strong><p>Vacantes:</p></strong>
             <p>{schedule}</p>
            </div>
          </div>
        </div>
        <div className="employee-conversation-card__description-buttons-container">
          <div className="employee-conversation-card__description-container">
            {description}
          </div>
          <div className="employee-conversation-card__button-container">
            <Link to={`/panel-empleado/inbox-empleado/${data.id}/${data.restaurantUserId}`}>
              <button className="employee-conversation-card__button">Ver chat</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeConversationCard;
